import React from 'react'
import { makeStyles } from '@material-ui/core'
import HMapTabDataItem from './HMapTabDataItem'

const HMapTabData = ({
  data,
  setCurrentPanel,
  allHeatMaps,
  setAllHeatMaps
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {data.map((dataItem, idx) => {
        return (
          <HMapTabDataItem
            key={`dataItem_${idx}`}
            dataItem={dataItem}
            setCurrentPanel={setCurrentPanel}
            allHeatMaps={allHeatMaps}
            setAllHeatMaps={setAllHeatMaps}
          />
        )
      })}
    </div>
  )
}

export default React.memo(HMapTabData)

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  }
}))
